import type { Vec3 } from "@dust/world/internal";
import { skipToken, useQuery } from "@tanstack/react-query";
import { useDustClient } from "../hooks/useDustClient";

export function usePlayerPositionQuery() {
  const { data: dustClient } = useDustClient();

  return useQuery<Vec3 | null>({
    queryKey: ["playerPosition"],
    queryFn: !dustClient
      ? skipToken
      : async () => {
          const position = await dustClient.provider.request({
            method: "getPlayerPosition",
            params: {
              entity: "0x",
            },
          });

          return [
            Math.floor(position.x),
            Math.floor(position.y),
            Math.floor(position.z),
          ];
        },
    enabled: !!dustClient,
    refetchIntervalInBackground: true,
    refetchInterval: 500,
    staleTime: 0,
    gcTime: 0,
  });
}
